"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TeamsIntegrationModalMetadataForm = require("./TeamsIntegrationModalMetadataForm");
Object.keys(_TeamsIntegrationModalMetadataForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TeamsIntegrationModalMetadataForm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TeamsIntegrationModalMetadataForm[key];
    }
  });
});